import React, { useState } from "react";
import backgroundImage from '../../images/header-homepage.webp';
import ProgressNavbar from './Components/progressNavbar';

import EmailNameStep from './SignUpSteps/emailNameStep';
import DetailsStep from './SignUpSteps/detailsStep';
import PasswordStep from './SignUpSteps/passwordStep';
import VerificationStep from './SignUpSteps/verificationStep';
import SuccessStep from "./SignUpSteps/successStep";
import useDocumentTitle from "../../Common/useDocumentTitle";

export default function SignUpForm() {
  const [currentStep, setCurrentStep] = useState(0);
  const [userInfo, setUserInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    institute: "",
    phoneNumber: "",
    tempPhoneNumber: "",
    fieldOfResearch: "",
    geoLocationOfResearch: "",
    password: "",
    secondPassword: "",
    termsAndPolicy: false,
  });

  const steps = [
    { name: 'Step 1', step: 0, componentName: EmailNameStep },
    { name: 'Step 2', step: 1, componentName: PasswordStep },
    { name: 'Step 3', step: 2, componentName: VerificationStep },
    { name: 'Step 4', step: 3, componentName: SuccessStep },
  ]

  useDocumentTitle("Sign Up");

  // Joins class names. Used for adding red borders to inputs with errors.
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  /**
   * Displays current step component.
   * 
   * @returns React Component.
   */
  function renderCurrentStep() {
    let params = {
      userInfo: userInfo,
      setUserInfo: setUserInfo,
      currentStep: currentStep,
      setCurrentStep: setCurrentStep,
      classNames: classNames
    }

    const Component = steps[currentStep].componentName;
    return <Component {...params} />;
  }

  return (
    <>
      <div className="h-screen md:flex dark:bg-gray-900">
        <div className="flex 2xl:w-2/5 w-full justify-center py-10 items-center bg-white dark:bg-gray-900">
          <div className="w-2/3 md:w-1/2 max-w-md">  {/* pb-32 */}
            {/* <div className="mt-4 flex justify-center">
              <img
                draggable="false"
                className="h-16"
                src={logo}
                alt="Arctic Research Foundation Logo"
              />
            </div> */}
            {currentStep !== steps.length - 1 &&
              <>
                <h1 className="mb-8 mt-24 text-2xl font-bold tracking-tight text-gray-900 sm:mt-10 sm:text-4xl text-center dark:text-white">
                  Sign Up
                </h1>

                <div className="mb-6">
                  <ProgressNavbar steps={steps.slice(0, 3)} currentStep={currentStep} classNames={classNames} />
                </div>
              </>
            }

            {renderCurrentStep()}

            {/* Don't show option to login on the last 2 steps to prevent confusion. */}
            {currentStep < steps.length - 2 &&
              <div className="mt-4 flex justify-center">
                <p className="text-sm sm:text-base font-medium text-gray-700 dark:text-gray-400">Already have an account? <a href="/signin" className="font-medium text-blue-700 dark:text-blue-500">Log in <span aria-hidden="true"> &rarr;</span> </a></p>
              </div>
            }
          </div>
        </div>

        <div className="relative overflow-hidden lg:flex w-3/5 justify-around items-center hidden">
          <img
            draggable="false"
            className="aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto h-screen"
            src={backgroundImage}
            alt="Arctic plains landscapes"
          />
        </div>
      </div>
    </>
  )
}

/* 
  4 steps total:

  Step 1: EmailNameStep
  - Email
  - First name
  - Last name

  Step 2: DetailsStep
  - Institute / Organization
  - Phone Number
  - Research Field
  - Geographic Location of Research

  Step 3: PasswordStep
  - Password 
  - Confirm Password
  - I agree with the Privacy Policy and Terms of Use checkbox
  - Create Account button

  Step 4: VerificationStep
  - Verification Code
  - Verify button
*/